'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/math-intrinsics/floor.js
// module id = 5628
// module chunks = 0